import React from 'react';
import Typography from '../Typography';
import Select from '../Select';
import IconButton from '../IconButton';
/**
 * Table Pagination component. Can be used in Table component
 *
 * **Functional Spec:** https://github.com/invotra/invotra-components-spec/blob/develop/v0.3.0/components/datatable.md
 */
export default function Pagination(_a) {
    var _b = _a.count, count = _b === void 0 ? 0 : _b, _c = _a.limit, limit = _c === void 0 ? 0 : _c, _d = _a.offset, offset = _d === void 0 ? 0 : _d, handleChangePage = _a.handleChangePage, handleChangeLimit = _a.handleChangeLimit;
    var pageMax = offset + limit;
    if (pageMax > count) {
        pageMax = count;
    }
    return (React.createElement("div", { role: "navigation", "aria-label": "Table pager" },
        React.createElement("div", { className: "madonna-table-pagination" },
            React.createElement(Typography, { use: "body2" }, "Rows per page:"),
            React.createElement(Select, { options: ['10', '25', '50', '100'], value: limit.toString(), onChange: function (event) { handleChangeLimit(+(event.target.value)); }, enhanced: true }),
            React.createElement(Typography, { use: "body2", className: "madonna-table-pagination-caption" },
                offset + 1,
                "-",
                pageMax,
                " of ",
                count),
            React.createElement("div", { className: "madonna-table-pagination-actions" },
                React.createElement(IconButton, { icon: "keyboard_arrow_left", label: "Previous page", onChange: function () { handleChangePage(offset / limit - 1); }, disabled: offset === 0 }),
                React.createElement(IconButton, { icon: "keyboard_arrow_right", label: "Next page", onChange: function () { handleChangePage(offset / limit + 1); }, disabled: pageMax === count })))));
}
//# sourceMappingURL=Pagination.js.map